/**
 * MenuController.js - 菜单控制器（重构版 - 使用子模块）
 * 处理菜单状态管理和输入控制
 */
import InputHelper from './InputHelper.js';
import MenuNavigation from './Menu/MenuNavigation.js';
import MenuOperation from './Menu/MenuOperation.js';
import GameStateStore from './GameStateStore.js';

export default class MenuController {
    constructor(scene, menuUI, equipmentMenuUI, itemHandler, equipmentHandler) {
        this.scene = scene;
        this.menuUI = menuUI;
        this.equipmentMenuUI = equipmentMenuUI;
        this.itemHandler = itemHandler;
        this.equipmentHandler = equipmentHandler;

        this.state = {
            currentMenu: 'main',
            selectedOption: 0,
            equipmentInventoryIndex: 0,
            menuOptions: {
                main: ['道具', '装备', '状态', '战车管理', '组队', '退出'],
                items: [],
                equipment: [],
                status: [],
                team: []
            },
            // 道具分类状态
            itemCategory: 'all', // all, consumable, equipment, vehicle_equipment, material
            itemCategories: [
                { key: 'all', name: '全部' },
                { key: 'consumable', name: '消耗品' },
                { key: 'equipment', name: '角色装备' },
                { key: 'vehicle_equipment', name: '战车装备' },
                { key: 'material', name: '材料' }
            ]
        };
        
        // 初始化子模块
        this.navigation = new MenuNavigation(this);
        this.operation = new MenuOperation(this);
    }

    /**
     * 显示菜单
     * @param {string} menuType - 菜单类型
     * @param {Object} playerData - 玩家数据
     */
    showMenu(menuType, playerData) {
        this.navigation.showMenu(menuType, playerData);
    }

    /**
     * 初始化菜单数据
     * @param {Object} playerData - 玩家数据
     */
    initMenuData(playerData) {
        this.operation.initMenuData(playerData);
    }

    /**
     * 处理ESC键
     */
    handleEscapeKey() {
        this.navigation.handleEscapeKey();
    }

    /**
     * 设置输入控制
     */
    setupControls() {
        this.menuInput = InputHelper.bindMenuKeyboard(this.scene, {
            blockWhen: () => this.equipmentHandler.isSubMenuActive(),
            onUp: () => {
                if (this.state.currentMenu === 'equipment') {
                    this.navigation.handleEquipmentSlotNav('up');
                } else {
                    this.navigation.handleUpKey();
                }
            },
            onDown: () => {
                if (this.state.currentMenu === 'equipment') {
                    this.navigation.handleEquipmentSlotNav('down');
                } else {
                    this.navigation.handleDownKey();
                }
            },
            onLeft: () => {
                if (this.state.currentMenu === 'equipment') {
                    this.navigation.handleEquipmentSlotNav('left');
                } else if (this.state.currentMenu === 'items') {
                    this.navigation.handleCategoryLeft();
                }
            },
            onRight: () => {
                if (this.state.currentMenu === 'equipment') {
                    this.navigation.handleEquipmentSlotNav('right');
                } else if (this.state.currentMenu === 'items') {
                    this.navigation.handleCategoryRight();
                }
            },
            onAuxPrev: () => {
                if (this.state.currentMenu === 'equipment') {
                    this.navigation.handleEquipmentInventoryNav(-1);
                }
            },
            onAuxNext: () => {
                if (this.state.currentMenu === 'equipment') {
                    this.navigation.handleEquipmentInventoryNav(1);
                }
            },
            onSelect: () => this.operation.executeSelectedOption(GameStateStore.getPlayer()),
            onCancel: () => this.navigation.handleEscapeKey()
        }, { horizontal: true });
    }

    /**
     * 移除键盘监听
     */
    destroyControls() {
        if (this.menuInput) {
            this.menuInput.destroy();
            this.menuInput = null;
        }
    }

    /**
     * 获取当前菜单类型
     * @returns {string} 当前菜单类型
     */
    getCurrentMenu() {
        return this.state.currentMenu;
    }
}
